import { Button } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useServerApi } from "../hooks/userServerApi";

const ReportFwdOngoingPartyList = () => {
  const [loading, setLoading] = useState(false);
  const [api] = useServerApi();
  const { t } = useTranslation();

  const downloadReport = async () => {
    try {
      setLoading(true);
      await api.FwdAml.downloadOngoingPartyList();
    } catch (error) {
      showNotification({
        color: "red",
        message: error?.message || t("Failed to download report"),
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Button size="xs" mt="md" onClick={downloadReport} loading={loading}>
        {t("Download")}
      </Button>
    </div>
  );
};

export default ReportFwdOngoingPartyList;
